import { defineStore } from "pinia";
import { useHighlightsField } from "./lib/useHighlightsField";

export const useCurationHighlights = defineStore("curation-content-highlights-field", () => {
  return useHighlightsField({
    id: "highlights",
    fieldKey: "highlights",
    masterDataStoreKey: "highlights",
    searchPlaceholderKey: "experience.premade.search.highlights",
  });
});
